module.exports = __webpack_public_path__ + "e36eb239b3792d99afbf4cbb0389aaff.svg";